export const rangeRegex = /^(\d{1,3})\s*-\s*(\d{1,3})$/;
